import { useCallback, useEffect, useState } from "react";

const PARAM = "chain";

function readFromLocation(): string | null {
  if (typeof window === "undefined") return null;
  return new URLSearchParams(window.location.search).get(PARAM);
}

export function useActiveChainId(): [
  string | null,
  (id: string | null) => void,
] {
  const [chainId, setChainId] = useState<string | null>(readFromLocation);

  useEffect(() => {
    const onPopState = () => setChainId(readFromLocation());
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  const setActiveChainId = useCallback((id: string | null) => {
    const url = new URL(window.location.href);
    if (id) {
      url.searchParams.set(PARAM, id);
    } else {
      url.searchParams.delete(PARAM);
    }
    window.history.pushState({}, "", url);
    window.dispatchEvent(new PopStateEvent("popstate"));
  }, []);

  return [chainId, setActiveChainId];
}
